export const DOCUMENT_TYPE_CAB_TABLE_PRODDUCT = 'commerce.cabTableProduct';
export const DOCUMENT_TYPE_CAB_TABLE_STANDARD_SETTINGS = 'commerce.cabTableStandardSettings';

export const OBJECT_TYPE_PRODUCT_MATERIAL_OPTION = 'commerce.productMaterialOption';
export const OBJECT_TYPE_CAB_TABLE_PRODUCT_IMAGE_SETTINGS = 'commerce.cabTableProductImageSettings';
